<script setup lang="ts">
import { type PropType } from 'vue'

import { type Product, type ProductVariant } from '@/types';

import {
  HeartIcon,
} from '@heroicons/vue/24/outline'

const props = defineProps({
  product: {
    type: Object as PropType<Product>,
    required: true,
  },
  productVariant: {
    type: Object as PropType<ProductVariant>,
    required: true,
  },
})

const {
  addProductToWishlist,
  removeProductFromWishlist,
  isInWishlist
} = useWishlist()

const isFavourited = computed(() => {
  return isInWishlist(props.productVariant.id)
})

const addToFavouritesIntent = () => {
  if (isFavourited.value) {
    removeProductFromWishlist(props.product, props.productVariant, 1)
  } else {
    addProductToWishlist(props.product, props.productVariant, 1)
  }
}
</script>

<template>
  <button 
    type="button" 
    class="relative flex items-center justify-center w-14 aspect-square px-3 py-3 ml-4 text-gray-400 rounded-md bg-gray-50 hover:bg-gray-100 hover:text-gray-500 focus:bg-gray-100"
    @click="addToFavouritesIntent"
  >
    <HeartIcon
      class="flex-shrink-0 w-6 h-6 text-pink-500 fill-pink-500 fill-opacity-50 absolute translate-y-0 transform" 
      :class="{ 
        'animate-float -translate-y-32 transition-all duration-3000 ease-in-out': isFavourited,
        'opacity-0': !isFavourited 
      }"
      title="Add to favourites"
      aria-hidden="true"
      aria-label="Click to add this product to your favourites"
      tabindex="-1" 
    />
    <HeartIcon 
      class="flex-shrink-0 w-5 h-5 fill-opacity-50" 
      :class="{ 
        'text-pink-500 fill-pink-500': isFavourited 
      }"
      aria-hidden="true" 
    />
    
    <span 
      class="sr-only"
    >
      Add to favourites
    </span>
  </button>
</template>